import 'maphilight';

$(function() {
  $('#map-image').maphilight();
  $('#map-image-mobile').maphilight();
});
